import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { initializeAuth } from './store/slices/authSlice';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Display from './pages/Display';
import CentralAdmin from './pages/CentralAdmin';
import AdminOfficeManage from './pages/AdminOfficeManage';
import NotFound from './pages/NotFound';
import * as api from './services/api';
import './App.css';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated, userType } = useSelector((state: any) => state.auth);

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  const getDefaultRoute = () => {
    if (localStorage.getItem('admin-token')) {
      return <Navigate to="/admin" replace />;
    }
    if (localStorage.getItem('office-token')) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  };

  /**
   * At path "/": if subdomain (e.g. office.screen-rates.com) -> Display;
   * otherwise login/admin/dashboard.
   */
  function HomeOrDisplay() {
    const sub = api.getSubdomainSlug();
    if (sub) return <Display />;
    return getDefaultRoute();
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['office']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CentralAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/office/:officeId"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminOfficeManage />
            </ProtectedRoute>
          }
        />
        <Route path="/display/:officeId" element={<Display />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="/" element={<HomeOrDisplay />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
